/**
 * VendorProductAnalyticService
 * Service for managing vendor product analytics
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product analytic CRUD operations with product-specific queries
 */
export class VendorProductAnalyticService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductAnalyticService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductAnalyticService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all analytics for a specific product
     * @param productId - Product ID
     * @returns Array of vendor product analytic views
     */
    async getByProduct(productId) {
        const response = await this.getByProductRaw(productId);
        return response.data ?? [];
    }
    /**
     * Get all analytics for a specific product with full response
     * @param productId - Product ID
     * @returns ResponseData with array of vendor product analytic views
     */
    getByProductRaw(productId) {
        const url = this.buildUrl(`product/${productId}`);
        return this.http.get(url);
    }
}
VendorProductAnalyticService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductAnalyticService.BASE_PATH = 'api/vendor-product-analytics';
//# sourceMappingURL=VendorProductAnalyticService.js.map